export default function Footer() {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: '51吃瓜入口', href: '#hero' },
    { label: '51吃瓜网在线', href: '#cards' },
    { label: '51吃瓜网址', href: '#index' },
    { label: '51吃瓜APP下载', href: '#app' },
    { label: '51吃瓜在线观看', href: '#media' },
    { label: '51吃瓜网站入口', href: '#hero' },
  ];

  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading text-xl">
                51
              </span>
              <span className="font-heading text-xl text-background-50">51吃瓜网站</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              51吃瓜网站是全网最新最全的吃瓜视频与娱乐资讯聚合平台，覆盖娱乐圈动态、网红黑料、综艺爆料与今日吃瓜热点，提供51吃瓜网址导航、APP下载安装方式，安全直连不迷路。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              <a href="#hero" className="hover:text-primary-400 transition-colors cursor-pointer">快速导航</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-400">诚邀各类娱乐媒体、内容平台与品牌合作，敬请期待。</p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">联系我们</h4>
            <p className="text-sm text-background-300 mb-2">投稿爆料 / 商务合作</p>
            <a
              href="#contact"
              className="inline-block text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
            >
              点击进入联系页面 →
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {currentYear} 51吃瓜网站. 51吃瓜入口 | 51吃瓜网在线 | 51吃瓜网址 | 51吃瓜APP下载 | 51吃瓜在线观看 | 全网最新吃瓜视频资源.
          </p>
          <p className="text-xs text-background-500">
            仅供休闲娱乐参考，不构成任何建议
          </p>
        </div>
      </div>
    </footer>
  );
}